import React, { Component } from "react";
import MainPicture from "../Section/MainPicture";
import image from './img/centraliser-donnees.png';
import LeftPictureBackground from "../Section/LeftPictureBackground";
import picturemethodo from "./img/target.png";
import picturequality from "./img/quality.png";
import RightPicture from "../Section/RightPicture";
import CheckModule from "../Section/CheckModule";
import pictureevol from "./img/sf4life.png";
import technologies from "../../../static/images/technologies.png";
import symfony from "../../pages/img/symfony.png";
import nodejs from "./img/nodejs.png";
import angular from "./img/angular-react.png";
import database from "./img/base-de-donnee.png";
import elasticsearch from "./img/symfony-logo-compressor.png";
import html from "./img/html-css-js.png";

class ExpertSymfonyApp extends Component {
  render() {
    let title = "Expert Symfony";
    let goto = "En découvrir plus";
    let alt = "test";
    let description = ["Symfony est un ", <strong>Framework Open-source Français en PHP</strong>, ". Un Framework est un ensemble de composants qui forment une base de développement solide. Tout en laissant une grande souplesse, un framework permet de ne pas avoir à réinventer la roue.",
                <br />,<br />,"Aujourd'hui ",<strong>Symfony</strong>," est une ", <a href='/technologies-web' title='Découvrir nos technologies Web'>technologie web</a>," renommée et est utilisé au sein de nombreuses plateformes comme: BlaBlaCar, Meetic, Vogue, Total, ..."];
    let smalltitle = "La flexibilité au service du web";
    let titlemethodo = "Symfony pour quel type de projet ?";
    let descriptionmethodo = [
        "Symfony peut répondre à toute sorte de projets web, web services, portails, outils métiers, site E-Commerce, CRM, ... Il n'est cependant pas particulièrement adapté pour la réalisation de simples pages. Voici quelques cas d'utilisations de Symfony:", 
        <br />, <br />,
        <ul>
            <li>
                <strong>Votre site vitrine :</strong> Vous avez besoin d'un espace client ? de communications avec d'autres outils métiers ? Symfony conviendra parfaitement. il ne sera cependant pas adapté à un <a href="/site-internet" target="_blank" title="Créer son site Internet">site vitrine</a> composés de pages de contenu.
            </li>
            <li>
                <strong>Une application Web métier :</strong> Afin de développer des <a href="/application-web" title="Créer des applications métiers">outils métiers</a>, interconnectés avec votre système d'information ou non, symfony est parfaitement adapté. Ce framework permet d'intégrer vos processus métiers au sein de plateformes Web. 
            </li>
            <li><strong>Un portail d'entreprise Intranet ou Extranet :</strong>Que vous souhaitiez créer un espace client / fournisseur ou encore un portail collaboratif interne, Symfony est parfaitement adapté à ces besoins.</li>
            <li><strong>Un autre besoin sur-mesure ?</strong> La robustesse, la généricité, la sécurité et la qualité du framework Symfony lui permet d'être adapté à de nombeuses situations ou problématiques.</li></ul>
    ,"De manière général Symfony répond parfaitement aux problématiques complexes, à la mise en place d'API ou Web services, ou encore à la mise en place d'outils dynamiques."    
];
    let pictureMethodo = picturemethodo;
    let altmethodo = "Méthodologie agile Scrum en image";



    let smalltitleevol = "professionnalisme, normes et conventions...";
    let titleevol = "Pourquoi Symfony ?";
    let descriptionevol = ["Symfony est un framework dit professionel. Il impose une structure, des normes et des conventions que chaque développeur se doit de respecter. Parmis les avantages d'utiliser une telle plateforme on retrouve:",
        <br />,<br />,<ul><li><strong>L'architecture MVC</strong> (Modèle Vue Contrôleur) impose une structure logique et métier de l'application. Cette logique permet d'implémenter des processus métiers complexe bien plus facilement.</li>
        <li>Les fichiers de code web doivent <strong>respecter les conventions et normes de développements</strong> imposées. Cela garantit une facilité de maintenance, compréhension et reprise du projet.</li>
        <li>Symfony facilite l'implémentation de <strong>tests unitaires et fonctionnels</strong>. Ces tests permettent d'assurer une qualité de code et une qualité de rendu de la solution Web.</li>
        <li>Une très forte communauté Open-Source accompagne les développements de Symfony. Cela assure une stabilité, une qualité, une innovation et une qualité de documentation constante.  </li>
       </ul>,
       <br />, "Cette technologie permet de s'assurer d'une bonne ", <strong>qualité de développement</strong>,", de réutilisation et de résultat final associé à la diminution des bugs et autres régressions.", <br />, <br />, <a href="https://www.symfony.com" title="Découvrir Symfony" target="_blank" rel="nofollow">Site officiel de Symfony</a>];

    let altevol = "Intégration du portail dans votre système d'informations";



    let smalltitleCheck = "Nativement rapide" ;
    let titleCheck = "Conseils & expertise";
    let subtitle1Check = "Des équipes expérimentées";
    let text1Check = ["Nous proposons Symfony à nos client depuis la toute première version du framework (", <a href="/symfony-5" title="Découvrez les nouveautés de Symfony 5">La version 5 actuellement</a>, "). Notre expérience dans de multiples métiers comme l'agro-alimentaire, la santé, l'artisanat, l'IoT, la GMS GSB, ... pour ", <a href="/realisation" title="Réalisations Web">des projets</a>, " de toute taille nous permet de vous accompagner et conseiller au quotidien." ];
    let subtitle2Check = "Qualité";
    let text2Check = "Pour l'ensemble des projets symfony que nous prenons en charge ou reprenons, nous mettons en place notre processus de développement éprouvé basé sur l'écriture de tests unitaires et fonctionnels automatisés.";
    let subtitle3Check = "Souplesse";
    let text3Check = "Afin de vous proposer un accompagnement pour votre projet le plus souple possible, nous travaillons à l'aide de la méthode Agile SCRUM qui vous assure une souplesse dans l'implémentation de votre projet.";
    let pictureCheck = picturequality;
    let altCheck = "La communication 360°";

    return (
      <div className="generic-services">
        <MainPicture title="Qu'est-ce que Symfony ?" description={description} picture={elasticsearch} alt={alt} />
        <RightPicture smalltitle={smalltitleevol} title={titleevol} description={descriptionevol} picture={pictureevol} alt={altevol} />
        <LeftPictureBackground smalltitle={smalltitle} title={titlemethodo} description={descriptionmethodo} picture={pictureMethodo} alt={altmethodo} />
        <CheckModule 
                smalltitle={smalltitleCheck} 
                title={titleCheck}
                subtitle1={subtitle1Check}
                text1={text1Check}
                subtitle2={subtitle2Check}
                text2={text2Check}
                subtitle3={subtitle3Check}
                text3={text3Check}
                picture={pictureCheck}
                alt={altCheck}
        />
      </div>
    );
  }
}

export default ExpertSymfonyApp;



// WEBPACK FOOTER //
// ./src/components/Page/ExpertSymfonyApp.jsx